import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=424c0ace&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c0ace",
  null
  
)

export default component.exports